var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-start w-full justify-center",class:`my-${_vm.margin}`},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":_vm.small ? 20 : 24,"width":_vm.small ? 20 : 24}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }